import { c as _c } from "react/compiler-runtime";
import { Image } from "@opensea/next-ui-kit";
import { classNames } from "@opensea/ui-kit";
import ReactHlsPlayer from "react-hls-video-player";
import { ONBOARDING_BACKGROUND } from "@/constants/assets";
const baseClassName = "pointer-events-none fixed inset-0 size-full";
export function OnboardingBackground(t0) {
  const $ = _c(10);
  const {
    stepIndex: t1,
    className
  } = t0;
  const stepIndex = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] !== className) {
    t2 = classNames(baseClassName, className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== stepIndex) {
    t3 = stepIndex === 0 ? <ReactHlsPlayer autoPlay={true} className="z-10 block size-full bg-black object-cover opacity-20" loop={true} muted={true} playsInline={true} src="https://stream.mux.com/cXy8e1loh91GgA7g5NM2r6rv8aS4KCvRxrdYPrI0102Bs.m3u8" /> : null;
    $[2] = stepIndex;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== stepIndex) {
    t4 = stepIndex > 1 && <Image className={classNames(baseClassName, "z-0 scale-150 opacity-15 blur-[40px] saturate-50", "transition duration-1000 ease-out-quint", stepIndex === 0 && "hue-rotate-0", stepIndex === 1 && "hue-rotate-[10deg]", stepIndex === 2 && "hue-rotate-[20deg]", stepIndex === 3 && "hue-rotate-[30deg]", (stepIndex === 4 || stepIndex === -1) && "hue-rotate-[40deg]")} fill={true} src={ONBOARDING_BACKGROUND} />;
    $[4] = stepIndex;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}